import { Link } from "react-router-dom";

const Media = () => {
  return (
    <>
      <div className="mediatitle">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12 col-lg-6">
              <div className="page-tit">
                <h1>News 2025</h1>
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="breadcrumb-page">
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="#">Media</Link>
                  </li>
                  <li>
                    <Link to="/Media">News</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container media-sec ">
        <div className="row no-gutters">
          <div className="col-md-5">&nbsp;</div>
          <div className="col-md-2">&nbsp;</div>
          <div className="col-md-5 flex justify-end gap-4 my-4 text-center">
            <Link
              to="/Media2023"
              className="text-center shadow-md bg-blue-200 p-2 rounded-md border-1 border-blue-500"
            >
              <b>ARCHIVE 2023</b>
            </Link>
            <Link
              to="/Media2024"
              className="text-center shadow-md bg-blue-200 p-2 rounded-md border-1 border-blue-500"
            >
              <b>ARCHIVE 2024</b>
            </Link>
          </div>
        </div>
        <div className="row no-gutters ">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <ul
              // style={{ borderTop: "1px solid #ccc" }}
              className="list-group mb-5 pt-2 "
            >
              {/* //13-01-2025 update */}
              <a
                href="download/news/2025/Electronics Era, January 2025-Powering Sustainability_From Vision to Impact.pdf"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>Powering Sustainability: From Vision to Impact </h5>
                  <small>Electronics Era, January 2025</small>
                </li>
              </a>
              {/* //28-02-2025 update */}
              <a
                href="download/news/2025/Water Digest, Vol-XVIII-Issue-IV-Smart Pumping_Technology-driven Solutions for Climate Challenges.pdf"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    Smart Pumping: Technology-driven Solutions for Climate
                    Challenges
                  </h5>
                  <small>Water Digest, Vol-XVIII-Issue-IV</small>
                </li>
              </a>
              <a
                href="download/news/2025/B2B Purchase, February, 2025-Interview_Anil Sethi_Pump Academy.pdf"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5> iPUMPNET Cuts Wastewater Energy Use By 25 Per Cent</h5>
                  <small>B2B Purchase Magazine, February 2025</small>
                </li>
              </a>
              <a
                href="download/news/2025/B2B Purchase Online, 3 Feb 2025-A Forward-Thinking Budget for Projects-Views from Pump Academy Chairman.pdf"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    Review of Union Budget 2025-26 by Chairman, Pump Academy
                  </h5>
                  <small>B2B Purchase Online Edition, 3 February 2025</small>
                </li>
              </a>
              {/* //03-03-2025 update */}
              <a
                href="https://www.thehansindia.com/tech/the-role-of-predictive-maintenance-in-reducing-downtime-and-costs-in-water-pumping-948788"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    The Role of Predictive Maintenance in Reducing Downtime and
                    Costs in water pumping
                  </h5>
                  <small>The Hans India, 25 February 2025</small>
                </li>
              </a>{" "}
              <a
                href="https://www.dqindia.com/business-technologies/smart-water-management-how-intelligent-pumping-systems-solve-global-water-challenges-8758802"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    Smart water management: How intelligent pumping systems solve global water challenges?
                  </h5>
                  <small> DataQuest, 26 Feb 2025 </small>
                </li>
              </a>
              <a
                href="https://www.cioandleader.com/from-legacy-to-smart-infrastructure-the-digital-evolution-of-pumping-stations/"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    From Legacy to Smart Infrastructure: The Digital Evolution of Pumping Stations
                  </h5>
                  <small> CIO & Leader, February 27, 2025 </small>
                </li>
              </a>
              {/*  */}
              <a
                href="https://responsibleus.com/how-pumping-systems-can-contribute-to-a-greener-future"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    How Pumping Systems Can Contribute To A Greener Future
                  </h5>
                  <small>Responsible us,  Feb 28, 2025 </small>
                </li>
              </a><a
                href="https://thecsrjournal.in/reducing-carbon-footprint-pumping-stations-role-ai-iot/"
                target="_blank"
              >
                <li className="list-group-item drop-shadow-md ">
                  <h5>
                    Reducing Carbon Footprint in Pumping Stations: The Role of AI and IoT
                  </h5>
                  <small> The CSR Journal,  March 1, 2025 </small>
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default Media;
